module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "contents"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/prologue#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 ‘Would You Like to Join the Army?’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2 ‘Their Tax in Blood’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 ‘They Threw Us In’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Blitzkrieg")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 ‘They Just Kept Marching Us’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 ‘A Ring of Steel and Fire’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Dynamo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 ‘Just Follow the Ferries’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 ‘Blood All Over Your Hands’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 ‘The Hour Is Too Solemn’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 ‘What Have We Let Ourselves In For?’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 ‘I’ll Come Looking for You!’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Remote in Some Dream of Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 ‘Beyond the Limits of Endurance’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Spontaneous Legend")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 ‘Very Well – Alone’")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Guilt and the Wonder")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Moment of Dunkirk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocapp1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocapp"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknow#acknow",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocapp"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/further#further",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocapp"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocapp"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/photo",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Photographs")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 60
// module chunks = 0